module.exports = __webpack_public_path__ + "76b3f5774e21b04186c159e75092b6a5.svg";